import AsyncRoute from '../components/AsyncContainer/AsyncContainer'

// registration routes
export const Register = AsyncRoute(() =>
  import('../components/Pages/Registration/Registration')
)
